import { createSlice } from "@reduxjs/toolkit";

const initialTimetableState = {
  actionsLoading: false,
  courseHours: [],
};

export const studentTimetableSlice = createSlice({
  name: "studentTimetable",
  initialState: initialTimetableState,
  reducers: {
    startCall: (state) => {
      state.actionsLoading = true;
    },
    // getTimetable
    timetableFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.authorities = action.payload.authorities;

      if (action.payload.entity) {
        state.courseHours = action.payload.entity.courseHours;
        state.timetable = action.payload.entity.timetable;
      }
    },
    // cleanTimetableState
    timetableStateCleaned: (state) => {
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.courseHours = [];
      state.timetable = [];
    }
  }
});